import { LOGO_SRC } from "@/components/Logo";
import { Mail } from "lucide-react";
import { scrollToId } from "@/lib/scroll";

const LINKS = [
  { label: "Services", id: "services" },
  { label: "Approach", id: "approach" },
  { label: "Why AiCendor", id: "why" },
  { label: "Insights", id: "insights" },
  { label: "Book a call", id: "book" },
  { label: "Contact", id: "contact" },
];

const DISCIPLINES = [
  "AI Governance",
  "Cybersecurity",
  "Enterprise Risk",
  "PMO & Transformation",
];

export default function Footer() {
  const year = new Date().getFullYear();
  return (
    <footer className="border-t border-gold/15 bg-surface/40">
      <div className="mx-auto max-w-7xl px-6 py-16 lg:px-10">
        <div className="grid gap-14 md:grid-cols-12">
          <div className="md:col-span-5">
            <div
              className="inline-block border border-gold/40 bg-[#F8F5EC] p-6 lg:p-8"
              data-testid="footer-brand-plate"
            >
              <img
                src={LOGO_SRC}
                alt="AiCendor — AI Governance, Cybersecurity, Enterprise Risk, PMO & Transformation"
                data-testid="footer-logo"
                className="h-28 w-auto lg:h-32"
              />
            </div>
            <p className="mt-6 max-w-xs font-mono text-[10px] uppercase tracking-[0.25em] text-slate-500">
              Govern with confidence. Transform with purpose.
            </p>
          </div>

          <div className="md:col-span-3">
            <p className="font-mono text-[10px] uppercase tracking-[0.3em] text-gold">Navigate</p>
            <nav className="mt-6 flex flex-col items-start gap-4">
              {LINKS.map((l) => (
                <button
                  key={l.id}
                  data-testid={`footer-link-${l.id}`}
                  onClick={() => scrollToId(l.id)}
                  className="link-underline font-mono text-[11px] uppercase tracking-[0.22em] text-slate-400 transition-colors hover:text-white"
                >
                  {l.label}
                </button>
              ))}
            </nav>
          </div>

          <div className="md:col-span-4">
            <p className="font-mono text-[10px] uppercase tracking-[0.3em] text-gold">The practice</p>
            <ul className="mt-6 space-y-3">
              {DISCIPLINES.map((d) => (
                <li key={d} className="flex items-center gap-3 text-sm font-light text-slate-300">
                  <span className="h-1 w-1 rotate-45 bg-gold" aria-hidden="true" />
                  {d}
                </li>
              ))}
            </ul>
            <a
              href="mailto:info@aicendor.com"
              data-testid="footer-email-link"
              className="mt-8 flex items-center gap-3 text-sm text-slate-300 transition-colors hover:text-gold"
            >
              <Mail className="h-4 w-4 text-gold" />
              info@aicendor.com
            </a>
          </div>
        </div>

        <div className="mt-14 flex flex-col justify-between gap-4 border-t border-white/10 pt-8 sm:flex-row">
          <p className="font-mono text-[10px] uppercase tracking-[0.25em] text-slate-600">
            © {year} AiCendor. All rights reserved.
          </p>
          <p className="font-mono text-[10px] uppercase tracking-[0.25em] text-slate-600">
            Govern with confidence. Transform with purpose.
          </p>
        </div>
      </div>
    </footer>
  );
}
